import React from 'react';
import { Button, notification, Icon } from 'antd';

const errorNotiStyle = { 
  width: 350,
  background: '#fef0ef',
  border:'solid 1px #fabeb9',
  color:'rgba(0, 0, 0, 0.65)',
  fontFamily: 'NotoSans',
  lineHeight: 1.5,
  letterSpacing: -0.5,
  padding: '16px 20px'
}

export const notiFormForError = (locale, description, message) => (
  notification.error({
    message: <div style={{color:'rgba(0, 0, 0, 0.75)', fontSize: 14}}>
                { message ? message : locale === 'ko'? '이런!' : 'Oops!'}
             </div>,
    description: <div style={{fontSize:12, fontFamily:'NotoSans-Light'}}>
                  { 
                    description.split('\n').map( line => 
                      <span key={line}>
                        { line.split('&nbsp;').map(sentence => <span key={sentence}>{sentence}&nbsp;</span>)}
                        <br/>
                      </span> 
                    ) 
                  }
                 </div>,
    duration:10,
    style: errorNotiStyle
  })
)

export const savePkgConfirm = (self, type, message, description, btn) => {
  
  const notiStyle = { 
    background: type === 'error' ? '#fef0ef' : '#ebf8f2',
    border: type === 'error' ? 'solid 1px #fabeb9' : 'solid 1px #a7e1c4',
    lineHeight: 1.5,
    letterSpacing: -0.5,
    padding: '16px 24px',
  }

  const btnStyle ={
    background: type === 'error' ? '#FF6060' : '#3BCA7C',
    boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.043)',
    borderRadius: '2px',
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '22px',
  }

  const key = `open${Date.now()}`;

  const onClick = () => {
    notification.close(key);
    
    if (type === 'success') {
      self.props.history.push('/mypage/packages-of-reviewed')
    }
  }

  const button = (
    <Button size='small' style={btnStyle} onClick={onClick}>
      <Icon type='right' />
      {btn}
    </Button>
  )

  notification[type]({
    message: <div style={{fontFamily:'Roboto', fontWeight:500, letterSpacing:'0.1px', color:'rgba(0, 0, 0, 0.87)', fontSize: 14}}>{message}</div>,
    description: <div style={{fontSize:12,fontWeight:300,color:'rgba(0, 0, 0, 0.6)'}}>
                  { description.split('\n').map( line => <span key={line}>{line}<br/></span> ) }
                 </div>,
    duration:0,
    className: 'custom-notification',
    style: notiStyle,
    btn: button,
    key: key,
  });
}